import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6741082c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-map-marker fas" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-check fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_page_header_component = _resolveComponent("page-header-component")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      header: _withCtx(() => [
        _createVNode(_component_page_header_component, {
          title: _ctx.$t('label.samplingPointList')
        }, {
          right: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: "search",
              modelValue: _ctx.query,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
            }, {
              prefix: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.samplingPoints,
          stripe: "",
          "row-class-name": _ctx.tableRowClassName,
          style: {"width":"100%"},
          "scrollbar-always-on": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _ctx.$t('label.name'),
              width: "280"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "code",
              label: _ctx.$t('label.code'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.code ? scope.row.code : "-"), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "station",
              label: _ctx.$t('label.station'),
              width: "280",
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_select, {
                  modelValue: scope.row.station,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.station) = $event),
                  "value-key": "id",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('label.noStation'),
                      value: null
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: _ctx.$t('label.stations'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.changeStation(scope.row)),
                  title: _ctx.$t('btn.stations'),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick", "title"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: _ctx.$t('label.save'),
              align: "center",
              "header-align": "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.saveChanges(scope.row)),
                  title: _ctx.$t('btn.save'),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick", "title"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "row-class-name"]),
        _createVNode(_component_el_pagination, {
          class: "app-table",
          layout: "total, sizes, prev, pager, next, jumper",
          currentPage: _ctx.currentPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
          "page-sizes": [10, 20, 50, 100],
          "page-size": _ctx.rowPerPage,
          total: _ctx.totalRows,
          onSizeChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePaginationSize($event))),
          onCurrentChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePaginationPage($event)))
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}